import { BasePalette, Palette } from '../general/color-palette';
import { Theme } from '../general/theme';
import { TextDirection } from '../general/text-direction';

const grey: BasePalette = {
  100: '#000000', // Black
  150: '#262626', // Nero
  200: '#333333', // Night Rider
  250: '#3B3938', // Black Light
  300: '#5F5F5F', // Zambezi
  350: '#646869', // Pale Sky
  400: '#6E6E6E', // Anthracite grey
  450: '#796F6E', // Ferra
  470: '#787B80', // Citroen grey
  480: '#A9B1B3',
  500: '#A19A99', // Nobel
  550: '#AFADC3', // Wistful
  600: '#B8B3B2', // Ferra
  700: '#C4C4C4', // Silver
  725: '#CAC6C5', // Alto
  730: '#CCCCCC', // Szürke
  750: '#CDCDCD', // Very Light Grey
  775: '#D0CBCB', // Very Light Grey
  800: '#E2E2E2', // Light Gainsboro
  825: '#E4E2E2', // Silver Light
  850: '#F0F0F0', // White Smoke
  860: '#F5F5F5',
  875: '#F2F1F0', // Hint Of Red
  900: '#FFFFFF', // White
};

const beige: Palette = {
  100: '#846547', // Dark Wood
  200: '#8F7869', // Squirrel
  300: '#9B9386', // Nomad
  400: '#B48F6D', // Gold main (Mongoose)
  500: '#CDBBAB', // Grain Brown
  600: '#DCCFBB', // Blanc
  700: '#E4DFCE', // Orange White
  800: '#F0E9E2', // Desert Storm
  850: '#F1F0F0', // Desert Storm
  900: '#F1EFE6', // Light gold (Alabaster)
};

const blue: Palette = {
  100: '#57718A', // Sexy blue
  200: '#DA291C', // Another sexy red
  300: '#3B3938', // Sexy GrayFish
  400: '#D02D27',
};

export const citroenTheme: Theme = {
  currentDirection: 'ltr',
  color: {
    base: grey,
    primary: blue,
    secondary: beige,
    accent: [] as Palette,
  },
  font: {
    normal: 'Citroen, Arial',
    primary: 'Citroen, Arial',
  },
  fontSize: {
    small: 13,
    normal: 16,
    big: 20,
    bigger: 24,
    large: 28,
    extraLarge: 36,
    huge: 40,
  },
  breakPoint: {
    mobile: 450,
    tablet: 960,
    smallDesktop: 1280,
  },
  get direction() {
    return this.currentDirection;
  },
  set direction(direction: TextDirection) {
    this.currentDirection = direction;
  },
};
